import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaDecisionTemplates = React.lazy(() =>
    import('../NebulaDecisionTemplates')
);
const nebulaDecisionTemplatesRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_DECISION_TEMPLATES_PAGE,
        element: <NebulaDecisionTemplates />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaDecisionTemplatesRoutesRegistry;
